import cx from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';

import { AnimateChangeInHeight } from 'lib/common/components/AnimateChangeInHeight/AnimateChangeInHeight';
import Text from 'lib/common/components/Text';

import { useAIContext } from '../../Context';
import { TIQDisplayMode } from '../constants/IQDisplayMode';
import RefineMenuItem from './components/EvaluateMenuItem';
import { IQRefineItems } from './constants/IQRefineItems';

import styles from './iq-refine-menu.module.scss';

export const IQRefineModes = ({
  displayMode,
  showAcceptForRewrites = true,
}: {
  displayMode: TIQDisplayMode;
  showAcceptForRewrites?: boolean;
}) => {
  const {
    state: { IQEnabled, IQFeaturesEnabled, IQFeatureConfig, selectedAction },
  } = useAIContext();

  const iqFeatureConfigModes = IQFeatureConfig.AI_REFINE?.modes;

  if (!iqFeatureConfigModes || !IQEnabled || !IQFeaturesEnabled.includes('AI_REFINE')) {
    return null;
  }

  const renderModes = IQRefineItems.filter(({ modeID }) => {
    return iqFeatureConfigModes?.[modeID];
  });

  const displayModeLower = displayMode.toLowerCase();

  return (
    <AnimateChangeInHeight>
      <AnimatePresence>
        {selectedAction && (
          <motion.div
            className={cx(styles['iq-refine-menu'], styles[`iq-refine-menu--${displayModeLower}`])}
            exit={{ opacity: 0, transition: { duration: 0.2 } }}
          >
            {!renderModes.length && (
              <Text color={'darkGrey'} className={styles['iq-refine-menu--empty-text']}>
                It looks like your Administrator hasn’t enabled any feedback rules. Try reaching out to them for help.
              </Text>
            )}
            {renderModes.map((item) => (
              <RefineMenuItem
                key={item.title}
                item={item}
                displayMode={displayMode}
                showAcceptForRewrites={showAcceptForRewrites}
              />
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </AnimateChangeInHeight>
  );
};
